import React from 'react'
import MediaQuery from 'react-responsive';
import { DFPSlotsProvider, AdSlot } from 'react-dfp';
import { Online } from 'react-detect-offline';
import IsNotDomestic from 'helpers/IsNotDomestic';


import classes from './Advert.module.scss'

const Advert = (props) => {
	return (		
		<div className={classes.Advert}>
			<IsNotDomestic>
				<Online>
					<MediaQuery maxWidth={classes.screenMdMax}>
						<DFPSlotsProvider targetingArguments={{ column: props.content.column }} dfpNetworkId={`${props.content.networkID}`} adUnit={`${props.content.adUnit}`}>
							<div className={`MPU__Wrapper`}>
								<div className={`MPU__mpu`}>
									<p className={`ads_title MPU__Title`}>advertisement</p>
									<div className={`MPU__Ads`}>
										<AdSlot sizes={[ [300, 250] ]} />
									</div>
								</div>
							</div>
						</DFPSlotsProvider>
					</MediaQuery>

					<MediaQuery minWidth={classes.screenMd} maxWidth={classes.screenXlMax}>
						<DFPSlotsProvider targetingArguments={{ column: props.content.column }} dfpNetworkId={`${props.content.networkID}`} adUnit={`${props.content.adUnit}`}>
							<div className={`leaderboardWrapper`}>
								<div className={`leaderboard`}>
									<p className={`ads_title leaderboardTitle`}>advertisement</p>
									<div className={`leaderboardAds`}>
										<AdSlot sizes={[ [728, 90] ]} />
									</div>
								</div>
							</div>
						</DFPSlotsProvider>
					</MediaQuery>

					<MediaQuery minWidth={classes.screenXl}>
						<DFPSlotsProvider targetingArguments={{ column: props.content.column }} dfpNetworkId={`${props.content.networkID}`} adUnit={`${props.content.adUnit}`}>
						<div className={`billboardWrapper`}>
							<div className={`billboard`}>
								<p className={`ads_title billboardTitle`}>advertisement</p>
								<div className={`billboardAds`}>
									<AdSlot sizes={[ [970, 250] ]} />
								</div>
							</div>
						</div>
						</DFPSlotsProvider>
					</MediaQuery>
				</Online>
			</IsNotDomestic>
		</div>
	)
	
}

export default Advert